// extracted by mini-css-extract-plugin
export default {"melodyVideo":"ZK-z","isFullWidth":"_K-z","landingPageVideo":"aL-z","play":"bL-z","iframeVideo":"cL-z","playHidden":"dL-z","fullwidth":"eL-z"};